import { createSlice } from "@reduxjs/toolkit";

export const jobSlice = createSlice({
  name: "jobs",
  initialState: {
    list: []
  } as any,
  reducers: {
    setJobs: (state, action) => {
      state.list = action.payload;
      
    },
    addJobs: (state, action) => {
      console.log('action payload', action.payload);
      const js = [...state.list, ...action.payload];
      state.list = js;
    },
    editJob: (state, action) => {
      const jobIndex = state.list.findIndex((p: any) => p.id === action.payload.id);
      state.list[jobIndex] = action.payload;
    },
    removeJob: (state, action) => {
      state.list = state.list.filter((j: any) => j.id !== action.payload.id);
    },
  },
});

export const { setJobs, addJobs, editJob, removeJob } = jobSlice.actions;

export default jobSlice.reducer;
